import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
const toneStyles = {
    green: {
        wrapper: 'bg-[var(--mint-50)] text-[var(--emerald-text)] border-[rgba(20,192,142,0.28)]',
        dotStyle: {
            background: 'var(--emerald)',
            boxShadow: '0 0 0 2px rgba(20,192,142,0.2)',
        },
    },
    butter: {
        wrapper: 'bg-[var(--butter-50)] text-[var(--gold)] border-[rgba(245,197,66,0.45)]',
        dotStyle: {
            background: 'var(--butter-glow)',
            boxShadow: '0 0 0 2px rgba(245,197,66,0.25)',
        },
    },
    crimson: {
        wrapper: 'bg-[var(--rose-50)] text-[var(--crimson)] border-[rgba(226,77,114,0.35)]',
        dotStyle: {
            background: 'var(--crimson)',
            boxShadow: '0 0 0 2px rgba(226,77,114,0.22)',
        },
    },
    neutral: {
        wrapper: 'bg-[rgba(11,13,35,0.05)] text-[var(--ink-700)] border-[var(--line)]',
        dotStyle: {
            background: 'var(--ink-400)',
        },
    },
};
/**
 * Status pill — used for monitor health, subscription state, delivery
 * status, etc. Matches the `.pill.*` styles in the mockup exactly, with
 * the Chaosology pastel backgrounds + -glow dots.
 */
export function Pill({ tone = 'neutral', children, withDot = true, className }) {
    const t = toneStyles[tone];
    return (_jsxs("span", { className: clsx('inline-flex items-center gap-1.5 rounded-full px-2.5 py-[3px] pl-2 text-[11.5px] font-semibold whitespace-nowrap border', t.wrapper, className), style: { fontFamily: 'var(--f-sans)' }, children: [withDot && (_jsx("span", { "aria-hidden": true, className: "h-1.5 w-1.5 rounded-full", style: t.dotStyle })), children] }));
}
